export const SET_MENU_NAME = 'SET_MENU_NAME';

export const SEARCH_KEY = 'SEARCH_KEY';
export const LOADING_ON = 'LOADING_ON';
export const LOADING_OFF = 'LOADING_OFF';
export const LOADING_ALL_STATES = 'LOADING_ALL_STATES';

// Beneficiary --------------------------------------------------
export const STARTING_GET_BENEFICIARY_LIST = 'STARTING_GET_BENEFICIARY_LIST';
export const COMPLETE_GET_BENEFICIARY_LIST = 'COMPLETE_GET_BENEFICIARY_LIST';
export const FAILED_GET_BENEFICIARY_LIST = 'FAILED_GET_BENEFICIARY_LIST';

export const STARTING_GET_BENEFICIARY_LISTV2 = 'STARTING_GET_BENEFICIARY_LISTV2';
export const COMPLETE_GET_BENEFICIARY_LISTV2 = 'COMPLETE_GET_BENEFICIARY_LISTV2';
export const FAILED_GET_BENEFICIARY_LISTV2 = 'FAILED_GET_BENEFICIARY_LISTV2';

export const STARTING_CREATE_BENEFICIARY = 'STARTING_CREATE_BENEFICIARY';
export const COMPLETE_CREATE_BENEFICIARY = 'COMPLETE_CREATE_BENEFICIARY';
export const FAILED_CREATE_BENEFICIARY = 'FAILED_CREATE_BENEFICIARY';

export const STARTING_UPDATE_BENEFICIARY = 'STARTING_UPDATE_BENEFICIARY';
export const COMPLETE_UPDATE_BENEFICIARY = 'COMPLETE_UPDATE_BENEFICIARY';
export const FAILED_UPDATE_BENEFICIARY = 'FAILED_UPDATE_BENEFICIARY';

export const STARTING_DELETE_BENEFICIARY = 'STARTING_DELETE_BENEFICIARY';
export const COMPLETE_DELETE_BENEFICIARY = 'COMPLETE_DELETE_BENEFICIARY';
export const FAILED_DELETE_BENEFICIARY = 'FAILED_DELETE_BENEFICIARY';

export const COMPLETE_BANK_REQUEST = 'COMPLETE_BANK_REQUEST';
export const FAILED_BANK_REQUEST = 'FAILED_BANK_REQUEST';

export const COMPLETE_BPAY_REQUEST = 'COMPLETE_BPAY_REQUEST';
export const FAILED_BPAY_REQUEST = 'FAILED_BPAY_REQUEST';

// Payment --------------------------------------------------
export const RESET_PAYMENT_DATA_STORE = 'RESET_PAYMENT_DATA_STORE';

export const STARTING_GET_PAYMENT_LIST = 'STARTING_GET_PAYMENT_LIST';
export const COMPLETE_GET_PAYMENT_LIST = 'COMPLETE_GET_PAYMENT_LIST';
export const FAILED_GET_PAYMENT_LIST = 'FAILED_GET_PAYMENT_LIST';

export const STARTING_CREATE_PAYMENT = 'STARTING_CREATE_PAYMENT';
export const COMPLETE_CREATE_PAYMENT = 'COMPLETE_CREATE_PAYMENT';
export const FAILED_CREATE_PAYMENT = 'FAILED_CREATE_PAYMENT';

export const STARTING_UPDATE_PAYMENT = 'STARTING_UPDATE_PAYMENT';
export const COMPLETE_UPDATE_PAYMENT = 'COMPLETE_UPDATE_PAYMENT';
export const FAILED_UPDATE_PAYMENT = 'FAILED_UPDATE_PAYMENT';

export const STARTING_DELETE_PAYMENT = 'STARTING_DELETE_PAYMENT';
export const COMPLETE_DELETE_PAYMENT = 'COMPLETE_DELETE_PAYMENT';
export const FAILED_DELETE_PAYMENT = 'FAILED_DELETE_PAYMENT';

// Invoices -------------------------------------------------------
export const SET_CONFLICT_FIELDS = 'SET_CONFLICT_FIELDS';
export const SET_BENEFICIARY_DATA = 'SET_BENEFICIARY_DATA';

// Alert
export const STARTING_GET_ALERT_LIST = 'STARTING_GET_ALERT_LIST';
export const COMPLETE_GET_ALERT_LIST = 'COMPLETE_GET_ALERT_LIST';
export const FAILED_GET_ALERT_LIST = 'FAILED_GET_ALERT_LIST';

export const STARTING_MARK_SEEN_ALERT = 'STARTING_MARK_SEEN_ALERT';
